export const toggleMenu = () => ({
  type: 'TOGGLE_MENU'
});

export const addMenuItems = items => ({
  type: 'ADD_MENU_ITEMS',
  items: items
});
